export const PACKAGE_VERSION = "0.48.2";
